import { DateFormat, getAgeFromDob } from '@equip.health/ui';
import { DateTime } from 'luxon';

import { GlobalSearchSuggestion } from '~/lib/types/navbar/global-search';
import { getPreferredFullName } from '~/lib/util/patient.util';

export const toPatientSuggestion = ({
  avatarSrc,
  chosenName,
  dateOfBirth,
  firstName,
  lastName,
  userId,
}: Patient): GlobalSearchSuggestion => ({
  avatarSrc,
  primaryText: getPreferredFullName(chosenName, firstName, lastName),
  secondaryText: dateOfBirth
    ? [
        `${DateTime.fromFormat(
          dateOfBirth,
          DateFormat.shortYearMonthDay,
        ).toFormat(DateFormat.longDate)} - ${getAgeFromDob(
          dateOfBirth,
        )} years old`,
      ]
    : [],
  value: userId,
});

export const toInquirySuggestion = ({
  channel,
  inquiryDate,
  inquiryId,
  patient,
  patientAge,
}: InquiryListItemResponse): GlobalSearchSuggestion => {
  const fullName = getPreferredFullName(
    patient.chosenName,
    patient.firstName,
    patient.lastName,
    false,
  );
  let dobOrAge;
  if (patient.dateOfBirth) {
    dobOrAge = DateTime.fromFormat(
      patient.dateOfBirth,
      DateFormat.shortYearMonthDay,
    ).toFormat(DateFormat.longDate);
  } else if (patientAge) {
    dobOrAge = `${patientAge} years old`;
  }
  const formattedInquiryDate = DateTime.fromJSDate(
    new Date(inquiryDate),
  ).toFormat('MMM d, yyyy');
  return {
    additionalPrimaryText: patient.chosenName
      ? [`(${patient.firstName})`]
      : undefined,
    badgeText: channel,
    primaryText: fullName,
    secondaryText: [
      `${dobOrAge ? `${dobOrAge} - ` : ''}Created ${formattedInquiryDate}`,
    ],
    value: inquiryId,
  };
};

const NUMERIC_REGEX = new RegExp('^[0-9]*$');

export const addPhoneNumberPrefix = (searchString: string): string => {
  const parts = searchString.split(' ');
  const resultParts = [];
  parts.forEach((p) => {
    if (NUMERIC_REGEX.test(p)) {
      if (p.startsWith('1')) resultParts.push(`+${p}`);
      else resultParts.push(`+1${p}`);
    } else {
      resultParts.push(p);
    }
  });
  return resultParts.join(' ');
};
